var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11781",
    "data-name": "Group 11781",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.963,
    height: 87.221,
    viewBox: "0 0 86.963 87.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21255",
    "data-name": "Path 21255",
    d: "M403.228,71.25h3.316a.369.369,0,0,0,0-.739h-3.316a.369.369,0,0,0,0,.739Z",
    transform: "translate(-351.158 -59.529)",
    fill: "#1cadd7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21256",
    "data-name": "Path 21256",
    d: "M317.9,71.25h3.316a.369.369,0,0,0,0-.739H317.9a.369.369,0,0,0,0,.739Z",
    transform: "translate(-279.094 -59.529)",
    fill: "#1cadd7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21257",
    "data-name": "Path 21257",
    d: "M275.238,71.25h3.316a.369.369,0,0,0,0-.739h-3.316a.369.369,0,0,0,0,.739Z",
    transform: "translate(-243.066 -59.529)",
    fill: "#1cadd7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21258",
    "data-name": "Path 21258",
    d: "M360.558,71.25h3.316a.369.369,0,0,0,0-.739h-3.316a.369.369,0,0,0,0,.739Z",
    transform: "translate(-315.121 -59.529)",
    fill: "#1cadd7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21259",
    "data-name": "Path 21259",
    d: "M194.439,73.687a17.416,17.416,0,0,0-3.191,1.122.369.369,0,0,0,.311.669,16.674,16.674,0,0,1,3.055-1.076.369.369,0,1,0-.176-.716Z",
    transform: "translate(-172.266 -62.2)",
    fill: "#1cadd7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21260",
    "data-name": "Path 21260",
    d: "M232.575,71.266h.018c.264-.012.533-.019.8-.019h2.5a.369.369,0,0,0,0-.739h-2.5c-.278,0-.559.007-.834.019a.37.37,0,0,0,.018.739Z",
    transform: "translate(-207.036 -59.526)",
    fill: "#1cadd7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21261",
    "data-name": "Path 21261",
    d: "M445.888,71.25H449.2a.369.369,0,0,0,0-.739h-3.316a.369.369,0,0,0,0,.739Z",
    transform: "translate(-387.185 -59.529)",
    fill: "#1cadd7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21262",
    "data-name": "Path 21262",
    d: "M94.275,325.426h27.753a.369.369,0,0,0,0-.739H94.275a.369.369,0,0,0,0,.739Z",
    transform: "translate(-90.237 -274.117)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21263",
    "data-name": "Path 21263",
    d: "M296.508,322.054a.922.922,0,1,1-.922-.924.922.922,0,0,1,.922.924",
    transform: "translate(-259.784 -271.114)",
    fill: "#1cadd7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21264",
    "data-name": "Path 21264",
    d: "M203.013,360.25H189.079a.369.369,0,0,0,0,.739h13.935a.369.369,0,0,0,0-.739Z",
    transform: "translate(-170.302 -304.141)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21265",
    "data-name": "Path 21265",
    d: "M197.487,395.8H189.08a.369.369,0,0,0,0,.739h8.407a.369.369,0,0,0,0-.739Z",
    transform: "translate(-170.303 -334.154)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21266",
    "data-name": "Path 21266",
    d: "M92.51,371.4a.369.369,0,0,0-.369.369v3.8a.369.369,0,1,0,.737,0v-3.8A.369.369,0,0,0,92.51,371.4Z",
    transform: "translate(-88.747 -313.554)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21267",
    "data-name": "Path 21267",
    d: "M122.138,359.55a.369.369,0,0,0-.369.369v5.646a.369.369,0,1,0,.737,0v-5.646A.369.369,0,0,0,122.138,359.55Z",
    transform: "translate(-113.768 -303.55)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21268",
    "data-name": "Path 21268",
    d: "M151.768,347.7a.369.369,0,0,0-.369.369v7.492a.369.369,0,1,0,.737,0v-7.492A.369.369,0,0,0,151.768,347.7Z",
    transform: "translate(-138.792 -293.545)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21269",
    "data-name": "Path 21269",
    d: "M94.393,195.429h32.434a.369.369,0,0,0,.369-.369V178.477a.369.369,0,0,0-.369-.369H94.393a.369.369,0,0,0-.369.369V195.06A.369.369,0,0,0,94.393,195.429Zm.368-16.583h31.7v15.845h-31.7Z",
    transform: "translate(-90.337 -150.367)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21270",
    "data-name": "Path 21270",
    d: "M168.364,195.41a5.965,5.965,0,1,0,5.955,5.965A5.966,5.966,0,0,0,168.364,195.41Zm0,11.192a5.227,5.227,0,1,1,5.217-5.227A5.228,5.228,0,0,1,168.364,206.6Z",
    transform: "translate(-148.09 -164.975)",
    fill: "#1cadd7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21271",
    "data-name": "Path 21271",
    d: "M186.313,216.747,183,218.665a.739.739,0,0,0,0,1.279l3.316,1.918a.737.737,0,0,0,1.105-.639v-3.837a.737.737,0,0,0-1.105-.639Z",
    transform: "translate(-165.166 -182.904)",
    fill: "#1cadd7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21272",
    "data-name": "Path 21272",
    d: "M538.012,331.63a5.906,5.906,0,1,0,5.866,5.906A5.874,5.874,0,0,0,538.012,331.63ZM540.493,338a2.526,2.526,0,1,1-2.941-2.966A2.53,2.53,0,0,1,540.493,338Zm-2.481,4.7a5.172,5.172,0,0,1-.9-10.258v1.934a3.279,3.279,0,1,0,3.918,4.39l1.391,1.4a5.109,5.109,0,0,1-4.412,2.533Zm4.757-3.232-1.521-1.532a3.283,3.283,0,0,0-3.4-3.683v-1.886a5.175,5.175,0,0,1,4.917,7.1Z",
    transform: "translate(-460.344 -279.978)",
    fill: "#1cadd7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21273",
    "data-name": "Path 21273",
    d: "M423.874,320.5a.369.369,0,0,0-.369-.369H391.146a.369.369,0,0,0,0,.739h32.359A.369.369,0,0,0,423.874,320.5Z",
    transform: "translate(-340.955 -270.268)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21274",
    "data-name": "Path 21274",
    d: "M428.783,355.68H414.849a.369.369,0,0,0,0,.739h13.935a.369.369,0,0,0,0-.739Z",
    transform: "translate(-360.972 -300.283)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21275",
    "data-name": "Path 21275",
    d: "M448.8,391.23H438.552a.369.369,0,0,0,0,.739H448.8a.369.369,0,0,0,0-.739Z",
    transform: "translate(-380.99 -330.296)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21276",
    "data-name": "Path 21276",
    d: "M392.978,195.429h32.434a.369.369,0,0,0,.369-.369V178.477a.369.369,0,0,0-.369-.369H392.978a.369.369,0,0,0-.369.369V195.06A.369.369,0,0,0,392.978,195.429Zm32.065-16.583V181.3l-14.1,9.528-9.771-7.737-7.827,5.736v-9.984Z",
    transform: "translate(-342.501 -150.367)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21277",
    "data-name": "Path 21277",
    d: "M499.767,200.349a2.85,2.85,0,1,0-2.846-2.85A2.852,2.852,0,0,0,499.767,200.349Zm0-4.962a2.112,2.112,0,1,1-2.109,2.112A2.113,2.113,0,0,1,499.767,195.387Z",
    transform: "translate(-430.596 -164.331)",
    fill: "#1cadd7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21278",
    "data-name": "Path 21278",
    d: "M156.9,16.476h-9.283l8.952-4.883a.373.373,0,0,0,0-.649L136.42.045a.371.371,0,0,0-.544.324l-.052,16.108H117.1a.369.369,0,0,0-.369.373v15.3h-5.88v-15.3a.37.37,0,0,0-.369-.391H84.991a16.933,16.933,0,0,1,1.818-1.534.369.369,0,0,0-.434-.6,17.688,17.688,0,0,0-2.418,2.131H70.677a.37.37,0,0,0-.369.391v55.53a.369.369,0,0,0,.369.369h6.809v4.06H74.354a.369.369,0,0,0-.369.369v4.136a5.908,5.908,0,0,0,5.9,5.906h67.8a5.908,5.908,0,0,0,5.9-5.906V77.178a.369.369,0,0,0-.369-.369h-3.132v-4.06H156.9a.369.369,0,0,0,.369-.369V16.849a.369.369,0,0,0-.368-.373ZM144.92,76.808H82.646v-4.06h27.837a.369.369,0,0,0,.369-.369V69.371h5.88v3.007a.369.369,0,0,0,.369.369h27.821Zm-28.19-8.176h-5.88V60.087h5.88Zm-5.88-9.284V37.316h5.88V59.348Zm21.265-38.72a1.105,1.105,0,1,1-1.105-1.107A1.106,1.106,0,0,1,132.116,20.628Zm-4.975,0a1.105,1.105,0,1,1-1.105-1.107A1.106,1.106,0,0,1,127.141,20.628Zm-4.974,0a1.105,1.105,0,1,1-1.105-1.107A1.106,1.106,0,0,1,122.166,20.628Zm14.38,1.048.032-9.974,18.362-.059Zm18.4-10.772-18.367.059.032-9.977ZM84.581,19.521a1.107,1.107,0,1,1-1.105,1.107,1.106,1.106,0,0,1,1.105-1.107Zm-4.974,0A1.107,1.107,0,1,1,78.5,20.628a1.106,1.106,0,0,1,1.105-1.107Zm-4.974,0a1.107,1.107,0,1,1-1.105,1.107,1.106,1.106,0,0,1,1.105-1.107ZM71.047,24.8h39.068V59.347h-1.447a4.992,4.992,0,0,0-3.956,1.949,3.144,3.144,0,1,0,.735.265,4.251,4.251,0,0,1,3.221-1.476h1.447V72.007H71.046Zm33.959,41.749a4.272,4.272,0,0,1,0-4.381,2.4,2.4,0,0,1,0,4.381Zm-.734.2a2.374,2.374,0,0,1-.239.012,2.4,2.4,0,0,1,0-4.8,2.353,2.353,0,0,1,.237.012,5.007,5.007,0,0,0,0,4.775Zm48.57,14.566a5.17,5.17,0,0,1-5.159,5.168h-67.8a5.17,5.17,0,0,1-5.159-5.168V77.545h30.4v1.834a3.138,3.138,0,0,0,3.132,3.138H119.31a3.138,3.138,0,0,0,3.132-3.138V77.545h30.4Zm-3.132-9.3H117.468V60.086h1.462a4.254,4.254,0,0,1,3.221,1.476,3.133,3.133,0,1,0,.735-.265,4.993,4.993,0,0,0-3.956-1.949h-1.462V24.818h39.068V72.007h-6.825ZM123.2,64.358a4.258,4.258,0,0,1-.6,2.19,2.4,2.4,0,0,1,0-4.38A4.251,4.251,0,0,1,123.2,64.358Zm.132-2.387a2.337,2.337,0,0,1,.237-.012,2.4,2.4,0,0,1,0,4.8,2.373,2.373,0,0,1-.238-.012,5.009,5.009,0,0,0,0-4.775Z",
    transform: "translate(-70.307 0.001)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21279",
    "data-name": "Path 21279",
    d: "M514.193,96.32h0l-4.988.016a.369.369,0,0,0,0,.739h0l4.988-.016a.369.369,0,0,0,0-.739Z",
    transform: "translate(-440.659 -81.318)",
    fill: "#1cadd7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21280",
    "data-name": "Path 21280",
    d: "M509.638,45.172h0l4.855-.015a.369.369,0,0,0,0-.739h0l-4.855.015a.369.369,0,0,0,0,.739Z",
    transform: "translate(-441.024 -37.5)",
    fill: "#1cadd7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21281",
    "data-name": "Path 21281",
    d: "M79.037,8.262h3.844a.371.371,0,0,0,.361-.444,2.128,2.128,0,0,1,3.224-2.224l.281.158a.371.371,0,0,0,.518-.173A4.115,4.115,0,0,1,95.1,7.9a.371.371,0,0,0,.363.431H99.39a.369.369,0,0,0,0-.739H95.879a5,5,0,0,0,0-.726,4.859,4.859,0,0,0-9.113-1.95,2.863,2.863,0,0,0-4.3,2.608H79.037a.369.369,0,0,0,0,.738Z",
    transform: "translate(-77.369 -2.009)",
    fill: "#1cadd7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.441fba977fdbb8bcaf598baa8f8131f7.svg";
export { ForwardRef as ReactComponent };